import { AdvancedImage } from '@cloudinary/react'
import styles from './LogoSection.module.scss'
import { LinkComponent } from '../../../components/UI/LinkComponent/LinkComponent'
import { SWEET_SCHOOL_URL } from '../../../const/consts'
import { useCloudinary } from '../../../hooks/useCloudinary'

export const LogoSection = () => {
  const { getImageInstance } = useCloudinary()
  const logoSlodka = getImageInstance(
    'szkolamajcake/logo/logo_slodka_szkola.png'
  )
  return (
    <div className={styles.ImageContainer}>
      <LinkComponent href={SWEET_SCHOOL_URL} aria-label='Słodka Szkoła'>
        <AdvancedImage cldImg={logoSlodka} alt='Szłodka Szkoła' />
      </LinkComponent>
    </div>
  )
}
